import produce from 'immer';
import { Reducer } from 'redux';

import { LanguagesState, LanguagesTypes } from '../types';

const initialState: LanguagesState = {
    isLoading: false,
    languages: [],
};

const languagesReducer: Reducer<LanguagesState> = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {
            case LanguagesTypes.GET_LIST: {
                draft.isLoading = false;
                draft.languages = action.payload.languages;
                break;
            }
            case LanguagesTypes.REQUEST_GET_LIST: {
                draft.isLoading = true;
                break;
            }
            default: {
                return draft;
            }
        }
    });
};

export { languagesReducer };
